/**
 * Pure ordering for a quote version chain (same `rootQuoteId`). Extracted from
 * the service layer so it can be node-tested without dragging the Firebase SDK
 * into the test (this repo unit-tests pure helpers; tsx wrappers get emulator
 * browser smokes).
 */

export interface QuoteVersionLike {
  id: string;
  metadata?: { version?: number } | null;
}

/** Dedupe by id, newest version first. Missing `metadata.version` = 1 (legacy
 *  root docs predate the version stamp). */
export const sortQuoteVersionsDesc = <T extends QuoteVersionLike>(quotes: T[]): T[] => {
  const byId = new Map<string, T>();
  for (const q of quotes) {
    if (!byId.has(q.id)) byId.set(q.id, q);
  }
  return [...byId.values()].sort((a, b) => (b.metadata?.version ?? 1) - (a.metadata?.version ?? 1));
};
